export default __webpack_public_path__ + "static/media/julian-paul-IP1oEacoXkM-unsplash.dffc7881.png";